//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { find } from 'lodash'

export default {
  nuxtI18n: {
    paths: {
      br: '/noticias',
      en: '/news',
      es: '/noticias'
    }
  },

  async asyncData({ $api, params, query, error }) {
    try {
      // Get news
      const { category } = params
      const { data, pagination, request } = await $api.news.showAll({
        ...query,
        slug_category: category || ''
      })

      // Get search
      const { search } = request

      // Get categories
      const categories = await $api.news.categories().then((response) => {
        return response.map((category) => {
          return {
            label: category.title,
            value: category.slug,
            seo: category.seo
          }
        })
      })

      // Get filter category
      const slug_category = find(categories, { value: category }) || ''

      if (category && !slug_category) {
        return error({ statusCode: 404 })
      }

      return {
        news: data,
        pagination,
        filter: {
          search,
          slug_category
        },
        categories
      }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      filter: {
        search: '',
        slug_category: ''
      },
      news: [],
      categories: [],
      pagination: {}
    }
  },

  head() {
    const { params } = this.$route
    const { category } = params

    if (category) {
      const categoryFounded = find(this.categories, { value: category })

      if (categoryFounded) {
        const { label, seo } = categoryFounded

        return this.$helpers.seoBuilder(this, {
          staticTitle: `${this.$t('title')} - ${seo ? seo.title : label}`,
          staticDescription: seo.description || ''
        })
      }
    }

    return this.$helpers.seoBuilder(this, {
      staticTitle: this.$t('title')
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/noticias'
        }
      ]

      const { params, fullPath } = this.$route
      const { category } = params

      if (category) {
        const categoryFounded = find(this.categories, { value: category })

        if (categoryFounded) {
          const { label } = categoryFounded

          breadcrumbs.push({
            name: label,
            path: fullPath
          })
        }
      }

      return breadcrumbs
    }
  },

  watchQuery: true,

  methods: {
    onFilter() {
      const { search, slug_category } = this.filter

      let path = this.localePath('/noticias')
      const query = {}

      if (slug_category && slug_category.value) {
        path += `/${slug_category.value}`
      }

      if (search) {
        query[this.$t('search')] = search
      }

      this.$router.push({
        path,
        query
      })
    }
  }
}
